import Icon from "@ant-design/icons";
import { ReactComponent as LinkedinSvg } from "./svg/linkedin.svg";

const LinkedinIcon = (props) => <Icon component={LinkedinSvg} {...props} />;

export default LinkedinIcon;
